import { Component, Vue, Prop as prop } from 'nuxt-property-decorator';

@Component
export default class CatalogPageComponent extends Vue {

    @prop()
    public pageCount!: number;

    @prop()
    public value!: number;


    get paginationLinks() {

        const buttons = [], startButtons = [], endButtons = [];

        let maxPage = Math.min(this.value + 2, this.pageCount);
        let minPage = Math.max(this.value - 2, 1);

        for (let i = minPage; i <= maxPage; i++) {
            buttons.push(this.createPageButton(i));
        }

        if (minPage > 1) {
            startButtons.push(this.createPageButton(1));
            if (minPage > 3) {
                startButtons.push(this.createSpaceButton());
            } else if (minPage !== 2) {
                startButtons.push(this.createPageButton(2));
            }
        }
        if (maxPage < this.pageCount) {
            if (maxPage < this.pageCount - 2) {
                endButtons.push(this.createSpaceButton());
            } else if (maxPage !== this.pageCount - 1) {
                endButtons.push(this.createPageButton(this.pageCount - 1));
            }
            endButtons.push(this.createPageButton(this.pageCount));
        }

        return Array.prototype.concat(startButtons, buttons, endButtons);
    }

    createPageButton(page: number, text?: string) {

        let link = null;

        if (this.value !== page) {
            link = this.$route.path;

            if (page > 1) {
                link += '?page=' + page;
            }
        }

        return {
            type: 'page',
            text: text || page.toString(),
            link: link,
            page,
            class: this.value === page ? 'active' : ''
        }
    }

    createSpaceButton(text: string = '...') {
        return {
            type: 'spacer',
            text: text,
        }
    }
}

